export default __webpack_public_path__ + "static/media/VerifiedIcon.56e6e189.svg";